module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.623d3aac.jpeg";